import { render } from "./BackendEntry.vue?vue&type=template&id=2f56a24d&scoped=true"
import script from "./BackendEntry.vue?vue&type=script&lang=ts"
export * from "./BackendEntry.vue?vue&type=script&lang=ts"

import "./BackendEntry.vue?vue&type=style&index=0&id=2f56a24d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2f56a24d"

export default script